var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-edit"},[(!_vm.$slots.default)?_c('div',{staticClass:"paragraph"},[_c('div',{staticClass:"paragraph-edit",attrs:{"contenteditable":"true"},on:{"focus":_vm.focus}})]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/block/block.vue